import React from 'react';
import ReactDOM from 'react-dom';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//import ProviderComponent from './core/redux/provider';
import RouterComponent from './core/router';
import { store } from './core/redux/store';
import reportWebVitals from './reportWebVitals';
import { Toast } from 'primereact/toast';
import { Alert } from './components';
import alertStyles from './components/alerts/styles.module.scss';
import { addLocale } from 'primereact/api';

// Prime React
// theme
// import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/themes/nova/theme.css'
// import 'primereact/resources/themes/saga-blue/theme.css';

// core
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css';

// custom
import './assets/styles/primereact.nova.css'
import Translate from './core/translate';
import { Provider } from 'react-redux';

Translate.configure();

window.app_enviroment = process.env.REACT_APP_ENV ?? process.env.NODE_ENV ?? window.app_enviroment ?? "ms-develop";
window.app_version = process.env.REACT_APP_VERSION ?? "{{VERSION}}";

//window.app_version = '{{VERSION}}';
function __checkHardRefresh() {
  if (window.location.pathname === '/borrar-cache') return;
  $.get(`/scripts/version.js?rnd=${Math.random()*10}`, function(data) {
    console.log("CHECK VERSION", window.app_version, "new version: ", data);
    console.log("enviroments", process.env);
    if (`${window.app_version}`.trim() !== `${data}`.trim())
      window.location.href = `${window.location.origin}/borrar-cache`;
      //(window.location.reload as any)(true);
  })
}
__checkHardRefresh();


const locale = {
  firstDayOfWeek: 1,
  dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
  monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  today: 'Hoy',
  clear: 'Limpiar',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sm'
};
addLocale("es", locale);

ReactDOM.render(
  <React.StrictMode>
    <Toast ref={(el: Toast) => Alert.SetToast(el)} className={alertStyles.alerts} />
    <Provider store={store}>
      <RouterComponent />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`/service-worker.js?jsversion=${process.env.REACT_APP_VERSION ?? 'test'}`).then(registration => {
      console.log('Service Worker registrado con éxito:', registration);
    }).catch(error => {
      console.log('Fallo en el registro del Service Worker:', error);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//serviceWorkerRegistration.register();